export const SET_APPLICATION_LEVEL_FULFILLED = 'SET_APPLICATION_LEVEL_FULFILLED';
export const SUBMIT_APPLICATION_FORM_PENDING = 'SUBMIT_APPLICATION_FORM_PENDING';
export const SUBMIT_APPLICATION_FORM_FULFILLED = 'SUBMIT_APPLICATION_FORM_FULFILLED';
export const SUBMIT_APPLICATION_FORM_FAILED = 'SUBMIT_APPLICATION_FORM_FAILED';
export const SUBMIT_APPLICATION_FORM_FILES_PENDING = 'SUBMIT_APPLICATION_FORM_FILES_PENDING';
export const SUBMIT_APPLICATION_FORM_FILES_FULFILLED = 'SUBMIT_APPLICATION_FORM_FILES_FULFILLED';
export const SUBMIT_APPLICATION_FORM_FILES_FAILED = 'SUBMIT_APPLICATION_FORM_FILES_FAILED';
